import React, { useCallback, useState } from 'react';
import { v4 as uuid } from 'uuid';

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// import styles from './components/TitleSections/Components/TitleComponent/TitleComponent.module.scss';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const checkIsFavourite = (productID) => {
  const wishlistArray = JSON.parse(localStorage.getItem('wishlistStorage'));

  if (!wishlistArray) return false;

  return wishlistArray.some((prodID) => prodID == productID);
};

const hasWishlistItems = () => {
  return !!JSON.parse(localStorage.getItem('wishlistStorage'))?.length;
};

// const toggleFavourite = (id) => {
//   let storedArray = JSON.parse(localStorage.getItem('wishlistStorage')) ?? [];
//
//   const addToFavourites = (prodID) => {
//     console.log(prodID, [...storedArray, prodID]);
//     storedArray = [prodID];
//   }
//   const removeFromFavourites = (prodID) => {
//     console.log(prodID, storedArray);
//     storedArray = storedArray.filter( item => item != prodID);
//   }
//
//   if (Array.isArray(id)) {
//     console.log("is array");
//     id.forEach( itemID => {
//       const tempID = parseInt(itemID);
//       console.log(tempID);
//       if(checkIsFavourite(tempID) === false) addToFavourites(tempID);
//     } );
//   } else {
//     const tempID = parseInt(id);
//     console.log(tempID);
//     checkIsFavourite(tempID) === true ? addToFavourites(tempID) : removeFromFavourites(tempID);
//   }
//   // localStorage.wishlistStorage = JSON.stringify(storedArray);
//   localStorage.setItem('wishlistStorage', JSON.stringify(storedArray));
//   console.log(localStorage.wishlistStorage);
// };

const toggleFavourite = (id, isAllFavourites = false) => {
  let storedArray = JSON.parse(localStorage.getItem('wishlistStorage')) ?? [];

  const searchExistingItem = (id) => {
    storedArray = checkIsFavourite(id) == true ? storedArray.filter((prodID) => prodID != id) : [...storedArray, id];
  };

  if (Array.isArray(id)) {
    id.forEach((itemID) => {
      if (isAllFavourites) {
        storedArray = storedArray.filter((id) => id !== itemID);
      } else if (checkIsFavourite(itemID) == false) storedArray = [...storedArray, itemID];
    });
  } else {
    searchExistingItem(parseInt(id));
  }
  // localStorage.wishlistStorage = JSON.stringify(storedArray);
  localStorage.setItem('wishlistStorage', JSON.stringify(storedArray));
  // console.log(storedArray);
};

const fetchProduct = (prodID, setWishlistProduct, setWishlistProductLoader, data) => {
  const product = data.products.find((prop) => prop.id == prodID);
  if (!!setWishlistProduct) setWishlistProduct(product);
  if (!!setWishlistProductLoader) setWishlistProductLoader(false);
  return product;
};

const generateKey = () => {
  return uuid();
};

const removeLastSlashes = (string) => {
  if (!!string?.length && string.length > 1 && string.charAt(string.length - 1) == '/') string = string.slice(0, -1);
  else return string;
  return removeLastSlashes(string);
};

const removeFirstSlashes = (string) => {
  let newString = addCustomPathToLink(string);

  if (newString.length > 1 && newString.charAt(0) == '/') newString = newString.slice(1);
  return newString;
};

const getCurrentPathname = (location) => {
  let trimmedPathname = removeLastSlashes(location.pathname);
  // return trimmedPathname.length > 1 ? trimmedPathname.substring(trimmedPathname.lastIndexOf('/') + 1) : trimmedPathname;
  if (!!trimmedPathname?.length && trimmedPathname.length > 1 && trimmedPathname.charAt(0) == '/') trimmedPathname = trimmedPathname.slice(1);
  return trimmedPathname;
};

const sanitizeType = (type, styles) => {
  let generatedStyles = '';

  if (!!type?.length && !!styles) {
    const typesArray = type.split(' ');

    typesArray.map((item) => {
      if (!!item && !!styles[item]) generatedStyles += styles[item] + ' ';
    });
    generatedStyles = generatedStyles.trim();
  }

  return generatedStyles;
};

const setVariant = (variant) => {
  localStorage.setItem('variant', JSON.stringify(variant));
};

const TitleOverlayWrapper = ({ children, titleWrapperRef, styles, api = null }) => {
  const [currentOverlayStyle, setCurrentOverlayStyle] = useState({});

  const handleResize = () => {
    const newStyles = {
      top: titleWrapperRef?.current?.offsetTop,
      left: titleWrapperRef?.current?.offsetLeft,
      width: titleWrapperRef?.current?.offsetWidth,
      height: titleWrapperRef?.current?.offsetHeight,
    };
    setCurrentOverlayStyle(newStyles);
  };

  React.useEffect(() => {
    if (titleWrapperRef != null) {
      setTimeout(() => {
        handleResize();
      }, '300');

      setTimeout(() => {
        handleResize();
      }, '1000');

      setTimeout(() => {
        handleResize();
      }, '1500');

      setTimeout(() => {
        handleResize();
      }, '2000');

      setTimeout(() => {
        handleResize();
      }, '2500');

      setTimeout(() => {
        handleResize();
      }, '3000');

      setTimeout(() => {
        handleResize();
      }, '3500');

      setTimeout(() => {
        handleResize();
      }, '4000');

      setTimeout(() => {
        handleResize();
      }, '4500');

      setTimeout(() => {
        handleResize();
      }, '5000');

      setTimeout(() => {
        handleResize();
      }, '15000');

      const sectionWrapper = titleWrapperRef?.current?.closest('section');
      const images = !!sectionWrapper && sectionWrapper.querySelectorAll('img');

      if (!images) {
        setTimeout(() => {
          handleResize();
        }, 0);
      } else {
        images.forEach((image) => image.addEventListener('load', handleResize));
      }

      const localStorageSetHandler = () => {
        handleResize();
      };

      window.addEventListener('resize', handleResize);
      document.addEventListener('itemInserted', localStorageSetHandler, false);

      return (_) => {
        window.removeEventListener('resize', handleResize);
        document.removeEventListener('itemInserted', localStorageSetHandler, false);
        !!images && images.forEach((image) => image.removeEventListener('load', handleResize));
      };
    }
  }, []);

  return (
    <>
      {children}
      {titleWrapperRef != null && (
        <div
          className={`${styles.titleOverlay} ${
            api?.attributes?.theme == 'theme-kitchen'
              ? styles.themeKitchen
              : api?.attributes?.theme == 'theme-default'
              ? styles.themeBathroom
              : api?.attributes?.theme == 'theme-interiors'
              ? styles.themeInteriors
              : api?.attributes?.theme == 'theme-trends'
              ? styles.themeTrends
              : ''
          }`}
          style={currentOverlayStyle}
        ></div>
      )}
    </>
  );
};

// const addCustomPathToLink = (link, isImage = false) => {
//   if (!!link?.length && (link.includes('https') || link.includes('http'))) return link;
//   const prefix =
//     !!link?.length && link.includes('.mp4')
//       ? 'https://cms.katalog.leroymerlin.pl/magazyn/public/storage/uploads'
//       : 'https://cms.katalog.leroymerlin.pl/magazyn/public/img';
//   const newPrefix = isImage ? prefix : process.env.PUBLIC_URL;
//   // const newPrefix = process.env.PUBLIC_URL;
//   if ((!!link?.length && link.includes(newPrefix)) || link == newPrefix) return link;

//   let newLink = link;
//   if (!!link?.length) {
//     if (newLink.charAt(0) == '/') {
//       newLink.slice(1);
//     }
//   }
//   newLink = `${newPrefix}/${newLink}`;
//   newLink = newLink.replace(/([^:]\/)\/+/g, '$1');

//   if (!link?.length || link.length == '/') {
//     newLink.slice(0, -1);
//   }
//   return newLink;
// };

//stare
// const addCustomPathToLink = (link, isImage = false) => {
//   if (!!link?.length && (link.includes('https') || link.includes('http'))) return link;

//   const prefix =
//     !!link?.length && link.includes('.mp4')
//       ? 'https://cms.katalog.leroymerlin.pl/magazyn/public/storage/uploads'
//       : 'https://cms.katalog.leroymerlin.pl/magazyn/public/img';
//   const newPrefix = isImage ? prefix : process.env.PUBLIC_URL;

//   if ((!!link?.length && link.includes(newPrefix)) || link === newPrefix) return link;

//   let newLink = link;
//   if (!!link?.length) {
//     if (newLink.charAt(0) === '/') {
//       newLink = newLink.slice(1);
//     }
//   }

//   newLink = `${newPrefix}/${newLink}`;
//   newLink = newLink.replace(/([^:]\/)\/+/g, '$1');

//   newLink = newLink.replace('width=1200&amp;height=1200', 'width=450&amp;');

//   if (!link?.length || link === '/') {
//     newLink = newLink.slice(0, -1);
//   }

//   return newLink;
// };

// const addCustomPathToLink = (link, isImage = false) => {
//   // console.log('Initial link:', link);

//   if (!!link?.length && (link.includes('https') || link.includes('http'))) return link;

//   const prefix =
//     !!link?.length && link.includes('.mp4')
//       ? 'https://cms.katalog.leroymerlin.pl/magazyn/public/storage/uploads'
//       : 'https://cms.katalog.leroymerlin.pl/magazyn/public/img';
//   const newPrefix = isImage ? prefix : process.env.PUBLIC_URL;

//   if ((!!link?.length && link.includes(newPrefix)) || link === newPrefix) return link;

//   let newLink = link;
//   if (!!link?.length) {
//     if (newLink.charAt(0) === '/') {
//       newLink = newLink.slice(1);
//     }
//   }

//   const segments = newLink.split('/');
//   if (segments.length > 3) {
//     newLink = segments.slice(0, 3).concat(segments.slice(-1)).join('/');
//   }

//   newLink = `${newPrefix}/${newLink}`;
//   newLink = newLink.replace(/([^:]\/)\/+/g, '$1');
//   newLink = newLink.replace('width=1200&amp;height=1200', 'width=450&amp;');

//   if (!link?.length || link === '/') {
//     newLink = newLink.slice(0, -1);
//   }

//   // console.log('Final link:', newLink);
//   return newLink;
// };

// const addCustomPathToLink = (link = '', isImage = false) => {
//   if (link.includes('https') || link.includes('http')) return link;

//   const defaultPrefix = 'https://cms.katalog.leroymerlin.pl/magazyn/public/';
//   const prefix = link.includes('.mp4') ? `${defaultPrefix}storage/uploads` : `${defaultPrefix}img`;
//   const newPrefix = isImage ? prefix : process.env.PUBLIC_URL;

//   if (link.includes(newPrefix) || link === newPrefix) return link;

//   let newLink = link.startsWith('/') ? link.slice(1) : link;

//   const segments = newLink.split('/');
//   if (segments.length > 3) {
//     newLink = [...segments.slice(0, 3), segments.pop()].join('/');
//   }

//   newLink = `${newPrefix}/${newLink}`.replace(/([^:]\/)\/+/g, '$1').replace('width=1200&amp;height=1200', 'width=450&amp;height=450');

//   if (!link || link === '/') {
//     newLink = newLink.slice(0, -1);
//   }

//   return newLink;
// };

const addCustomPathToLink = (link = '', isImage = false) => {
  if (link.includes('https') || link.includes('http')) return link;

  const defaultPrefix = 'https://cms.katalog.leroymerlin.pl/magazyn/public/';
  const prefix = link.includes('.mp4') ? `${defaultPrefix}storage/uploads` : `${defaultPrefix}img`;
  const newPrefix = isImage ? prefix : process.env.PUBLIC_URL;

  if (link.includes(newPrefix) || link === newPrefix) return link;

  let newLink = link.startsWith('/') ? link.slice(1) : link;

  const segments = newLink.split('/');
  if (segments.length > 3) {
    newLink = [...segments.slice(0, 3), segments.pop()].join('/');
  }

  // Replace width and height parameters
  newLink = newLink.replace('width=1200&amp;height=1200&amp', 'width=450&amp;height=450&amp');
  // Replace canvas parameters
  newLink = newLink.replace('canvas=1200,1200', 'canvas=500,500');

  newLink = `${newPrefix}/${newLink}`.replace(/([^:]\/)\/+/g, '$1');

  if (!link || link === '/') {
    newLink = newLink.slice(0, -1);
  }

  return newLink;
};

const getCurrentVariant = (variants) => {
  let currentVariant = null;

  if (!Array.isArray(variants)) {
    for (const [variantKey, variant] of Object.entries(variants)) {
      if (!currentVariant) {
        currentVariant = variant;
        currentVariant.name = variantKey;
      }
      variant.name = variantKey;
      if (variantKey == 'medium') {
        currentVariant = variant;
        currentVariant.name = variantKey;
      }
      if (!!variant?.startfoto) return variant;
    }
    return currentVariant;
  } else {
    for (const variantKey in variants) {
      const variant = variants[variantKey];
      if (!currentVariant) {
        currentVariant = variant;
        currentVariant.name = variantKey;
      }
      variant.name = variantKey;
      if (variantKey == 'medium') {
        currentVariant = variant;
        currentVariant.name = 'medium';
      }
      if (!!variant?.startfoto) return variant;
    }
  }
  return currentVariant;
};

const getVariantsCount = (variants) => {
  if (Array.isArray(variants)) {
    return variants.length;
  } else {
    let counter = 0;
    for (const [variantKey, variant] of Object.entries(variants)) {
      counter++;
    }
    return counter;
  }
};

const imageWrapperWithButtonRefFunction = (node) => {
  if (node !== null) {
    const childNode = node?.children[0];

    if (!!childNode && window.innerWidth < 992) {
      const setScrollPosition = () => {
        if (!!childNode) node.scrollLeft = childNode.offsetWidth / 2 - node.offsetWidth / 2;
      };
      new ResizeObserver(setScrollPosition).observe(childNode);
    }
  }
};

const mergeArrays = (array1, array2) => {
  if (!!array1) {
    if (!!array2) {
      return array1.concat(array2);
    }
    return array1;
  }
  return !!array2 ? array2 : null;
};

export {
  checkIsFavourite,
  toggleFavourite,
  generateKey,
  fetchProduct,
  removeFirstSlashes,
  removeLastSlashes,
  getCurrentPathname,
  sanitizeType,
  ScrollToTop,
  hasWishlistItems,
  setVariant,
  TitleOverlayWrapper,
  addCustomPathToLink,
  getCurrentVariant,
  getVariantsCount,
  imageWrapperWithButtonRefFunction,
  mergeArrays,
};
